import store from '@/store/store'
import router from '@/routes/router'

/**
 * Constant with error code from backend
 */
const UNAUTHORIZED_ERROR_CODE = 401

/**
 * @description
 * Make actions before send axios request.
 * In this case, this function add bypass param to request if
 * the Vue Environment Var "VUE_APP_BY_PASS_LOGIN" is "true",
 *
 * @param {Object} config
 * @return {Object} config
 */
const beforeRequest = config => {
    // Do something before request is sent
    if (process.env.VUE_APP_BY_PASS_LOGIN === 'true') {
        if (config.params == undefined) config.params = {} // For query with Models
        config.params.bypass = true
    }

    return config
}

/**
 * @description
 * Error request to backend,
 *
 * @param {Object} response
 * @return {Promise} response
 */
const errorRequest = function(error) {
    return new Promise(function(resolve, reject) {
        let moduleToken = getLoginToken_FromParams()
        if (
            error.response &&
            error.response.status === UNAUTHORIZED_ERROR_CODE &&
            moduleToken === undefined
        ) {
            // ignore guard if exist token in URL
            store.dispatch('AuthModule/logoutActions') // delete local storage user data
            router.push('/login')
        }
        throw error
    })
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getLoginToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1]
    } catch (err) {
        return undefined
    }
} // end function

export { beforeRequest, errorRequest }
